( function() {
    "use strict";

    angular
        .module( 'ccsTrApp' )
        .service( 'LotDTOCustomService', LotDTOCustomService );

    LotDTOCustomService.$inject = [ '$http', '$q' ];
    function LotDTOCustomService( $http, $q ) {
        var service = {

        };

        return service;
        
    }

})();
